import React from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import Page from 'components/page/page.component';
import DocumentList from 'components/document-list/document-list.component';

import { CodeDocs, ImportantDocs, PolicyDocs } from './documents';

const PolicyAndProcedures = () => {
    return (
        <Page className="policy-and-procedures" heroTitle="Policy and Procedures" heroSize="small" variant="no-flex">
            <Tabs defaultActiveKey="policy-and-procedures">
                <Tab eventKey="policy-and-procedures" title="Policy and Procedures">
                    <div className="documents">
                        {PolicyDocs && <DocumentList listTitle="policy" documents={PolicyDocs} />}
                    </div>
                </Tab>
                <Tab eventKey="important-documents" title="Important Documents">
                    <div className="documents">
                        {ImportantDocs && <DocumentList listTitle="important" documents={ImportantDocs} />}
                    </div>
                </Tab>
                <Tab eventKey="indiana-code" title="Indiana Code for Land Banking and Redevelopment">
                    <div className="documents">
                        {CodeDocs && <DocumentList listTitle="code" documents={CodeDocs} />}
                    </div>
                </Tab>
            </Tabs>
        </Page>
    );
};

export default PolicyAndProcedures;
